// Namespace context and texts that say where namespaces apply (docs/glossary.md).

/** Hint on the trust config and principal pages: these objects are tenant-wide. */
export const TENANT_WIDE_HINT =
  "Applies to every namespace in this tenant. Give access per namespace with a grant.";

const KEY_PREFIX = "prego.lastNamespace.";

/** The namespace the user chose last in this tenant, or null. Browser storage can fail; then null. */
export function lastNamespace(tenant: string): string | null {
  try {
    return window.localStorage.getItem(KEY_PREFIX + tenant);
  } catch {
    return null;
  }
}

/** Keeps the namespace the user chose, so the next form starts with it. */
export function rememberNamespace(tenant: string, ns: string): void {
  try {
    window.localStorage.setItem(KEY_PREFIX + tenant, ns);
  } catch {
    // Storage is blocked. The form then starts with "default".
  }
}

/**
 * The namespace a form starts with: the namespace in context (a link), else the last used one, else
 * "default", else the first one. A namespace that does not exist (any more) is skipped.
 */
export function initialNamespace(
  slugs: readonly string[],
  fromLink: string | undefined,
  last: string | null,
): string {
  for (const ns of [fromLink, last, "default"]) if (ns && slugs.includes(ns)) return ns;
  return slugs[0] ?? "";
}
